import { observer } from 'mobx-react-lite'
import { Input, Modal, Typography } from 'antd'
import { useNotification } from '@/Ship/Hooks/useNotification'
import type { ExecutorMessageModalStore } from '../../Stores/ExecutorMessageModalStore'

const { Text } = Typography

interface Props {
    store: ExecutorMessageModalStore
}

export const ExecutorMessageModal = observer(({ store }: Props) => {
    const { showSuccess, showError } = useNotification()

    return (
        <Modal
            title="Повідомлення водію"
            open={store.open}
            onOk={() => store.send({ success: showSuccess, error: showError })}
            onCancel={() => store.close()}
            confirmLoading={store.loading}
            okText="Відправити"
            cancelText="Скасувати"
        >
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginTop: 8 }}>
                <div>
                    <Text>Водій <span style={{ color: 'red' }}>*</span>:</Text>
                    <div style={{ marginTop: 6, display: 'flex', flexDirection: 'column', gap: 6 }}>
                        {store.assignments.map((a: any) => {
                            const driverName = a.driver?.fullName || a.driver?.title || '—'
                            const plate = a.vehicle?.registrationNumber || a.vehicle?.licensePlate || ''
                            const isSelected = store.selectedAssignmentUuid === a.uuid
                            return (
                                <label
                                    key={a.uuid}
                                    style={{
                                        display: 'flex', alignItems: 'center', gap: 8,
                                        padding: '6px 10px', borderRadius: 6, cursor: 'pointer',
                                        border: `1px solid ${isSelected ? 'var(--ant-color-primary, #e84923)' : 'rgba(255,255,255,0.12)'}`,
                                        background: isSelected ? 'rgba(232,73,35,0.08)' : 'transparent',
                                    }}
                                >
                                    <input
                                        type="radio"
                                        name="executor-message-driver"
                                        checked={isSelected}
                                        onChange={() => store.setSelectedAssignment(a.uuid)}
                                    />
                                    <span style={{ fontWeight: 500 }}>{driverName}</span>
                                    {plate && <Text type="secondary" style={{ fontSize: 12 }}>· {plate}</Text>}
                                    {a.id != null && <Text type="secondary" style={{ fontSize: 12 }}>· завд. #{a.id}</Text>}
                                </label>
                            )
                        })}
                    </div>
                </div>
                <div>
                    <Text>Текст повідомлення <span style={{ color: 'red' }}>*</span>:</Text>
                    <Input.TextArea
                        rows={3}
                        placeholder="Введіть текст повідомлення водію..."
                        value={store.message}
                        onChange={(e) => store.setMessage(e.target.value)}
                        style={{ marginTop: 6 }}
                        autoFocus
                    />
                </div>
            </div>
        </Modal>
    )
})
